module.exports = __webpack_public_path__ + "img/d_x-hannah-wits.23618d19.png";